import React, { useMemo } from "react";
import { Table } from "../../../../../shared/Table/Table";
import classes from "../../../newBusinessInsightsContent.module.scss";
import { useWalletCredits } from "./hooks/useWalletCredits";
import Header from "../../../components/Header";
import { useHeaderActions } from "../../../hooks/useHeaderActions";
import { Box } from "../../../../../shared/Box/Box";
import { Skeleton } from "../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../shared/Empty/Empty";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

const modalInfo = {
  title: "walletCreditsReport.info.title",
  rows: [
    "walletCreditsReport.info.clinicWalletCredits",
    "walletCreditsReport.info.providerWalletCredits",
  ],
};

const WalletCredits = () => {
  const { selectedClinic, period, apiPeriod } = useHeaderActions();
  const requestParams = {
    fromDate: apiPeriod.fromDate,
    toDate: apiPeriod.toDate,
    clinic_id:
      selectedClinic.value.value !== 0 ? [selectedClinic.value.value] : [],
  };
  const { data, isLoading } = useWalletCredits(requestParams);

  const isClinicDataEmpty = !isLoading && !data?.clinicWalletCredits?.length;
  const isProviderDataEmpty =
    !isLoading && !data?.providerWalletCredits?.length;

  const clinicData = useMemo(
    () =>
      data?.clinicWalletCredits.map((clinic) => ({
        clinicName: clinic.clinic_name,
        walletCredits: clinic.wallet_credits,
      })),
    [data],
  );

  const providerData = useMemo(
    () =>
      data?.providerWalletCredits.map((provider) => ({
        providerName: provider.provider,
        walletCredits: provider.wallet_credits,
      })),
    [data],
  );

  const clinics =
    useMemo(
      () =>
        data?.clinics.map((clinic) => ({
          label: clinic.clinic_name,
          value: clinic.id,
        })),
      [data],
    ) || [];

  return (
    <div className="flex-col font-14 gap-16">
      <Header
        title="Wallet Credits"
        selectedClinic={selectedClinic}
        clinics={clinics}
        period={period}
        downloadRoute={HTTP_ENDPOINTS.getWalletCredits()}
        requestParams={requestParams}
        modalInfo={modalInfo}
      />
      <div className="flex gap-16">
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Clinic Name", accessor: "clinicName" },
              { data: "Wallet Credits", accessor: "walletCredits" },
            ]}
            data={clinicData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isClinicDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Provider Name", accessor: "providerName" },
              { data: "Wallet Credits", accessor: "walletCredits" },
            ]}
            data={providerData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isProviderDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default WalletCredits;
